module.exports = __webpack_public_path__ + "img/figure0-offer3.79c6b988.png";